module.exports = __webpack_public_path__ + "media/A32.a7d670e4.mp3";